// extracted by mini-css-extract-plugin
module.exports = {"contentFrame":"GamePlay_contentFrame__3jXkp","reminderButton":"GamePlay_reminderButton__1tc-f","output":"GamePlay_output__3BekR","input":"GamePlay_input__3q7fN"};